import React from 'react';

export default class GoogleTagManager extends React.Component {

	componentDidMount(){
		if(!this.props.config)
			return console.warn('[GoogleTagManager]', 'no config');
		
		if(!this.props.config.activated)
			return console.debug('[GoogleTagManager]', 'not activated');

		if(!this.props.config.siteId)
			return console.warn('[GoogleTagManager]', 'no siteId config');
		

		console.debug('[GoogleTagManager]', 'is mounting');

		var ref = window.document.getElementsByTagName("script")[0];
		var script = window.document.createElement("script");

		var text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${this.props.config.siteId}');`;
		script.text = text;

		ref.parentNode.insertBefore(script, ref);
	}

	render() {
		return this.props.children || null;
	}
}
